import React from "react";
import { useState, useEffect } from "react";
import NavbarNew from "../Navbar/NavbarNew";
import Footer from "./Footer";
import axios from "axios";
import log from "../../logger";
import "./AboutUsPage.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";
import logo from "../Images/MRI2-removebg-preview.png";

const AboutUsPage = () => {
  const [storedUserObject, setstoredUserObject] = useState({});
  const navigate = useNavigate();
  const project = sessionStorage.getItem("project");
  const [isUserLoading, setIsUserLoading] = useState(true);
  const [role, setRole] = useState("");
  const username = storedUserObject.first_name;

  const handleLearnMore = () => {
    window.open("https://www.neuro42.ai/", "_blank");
  };
  const handleGetInTouch = () => {
    navigate("/contactUs");
  };
  const fetchUser = async () => {
    try {
      const response = await axios.get("/common/api/get_user/", {
        withCredentials: true,
      });
      setstoredUserObject(response.data.user_object);
    } catch (error) {
      log.error("Error fetching user", {
        endpoint: "/common/api/get_user/",
        method: "GET",
        project: project,
        response_status: 401,
        role: role,
        error_message: "Error fetching user",
        // error_stack: error.response?.data || error.message
      });
    } finally {
      setIsUserLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchUser();
    };

    fetchData();
  }, []);
  return (
    <div className="page-body">
      <NavbarNew username={username} />

      {/* <div className="page-layout">
        <div className="main-content">
          <div className="about-us-container"> */}
      {/* <h1 className="about-us-title">About Us</h1>
            <p className="about-us-description">Welcome to neuro42, Inc.!</p>
            <p className="about-us-description">
              neuro42, Inc. is a medtech Company advancing futuristic
              technologies for screening, diagnosis, and targeted treatment of
              neurological conditions. The Company is developing and
              commercializing a portable MRI, robotic and AI platform, backed by
              over 30 patents, for point-of-care imaging and interventions under
              live image guidance. neuro42 is founded by a team of serial
              entrepreneurs and innovators with a mission to improve lives
              through its patient-centric solutions.
            </p> */}
      <div className="shapes">
        <div className="shape rectangle"></div>
        <div className="shape circle"></div>
      </div>

      <div className="styled-line-main">
        <div className="line1-main"></div>
        <div className="line2-main"></div>
        <div className="line3-main"></div>
      </div>

      <div className="internal-info-section">
        <div className="info-content">
          <h2>neuro42, Inc.!</h2>
          <p>
            neuro42, Inc. is a medtech Company advancing futuristic technologies
            for screening, diagnosis, and targeted treatment of neurological
            conditions. The Company is developing and commercializing a portable
            MRI, robotic and AI platform, backed by over 30 patents, for
            point-of-care imaging and interventions under live image guidance.
            neuro42 is founded by a team of serial entrepreneurs and innovators
            with a mission to improve lives through its patient-centric
            solutions.
          </p>
          <div className="second-section-learn-more">
            <button className="learn-more-button" onClick={handleLearnMore}>
              Learn More
            </button>
            <button className="learn-more-button" onClick={handleGetInTouch}>
              Get In Touch
            </button>
          </div>
        </div>
        <div className="internal-info-image">
          <img src={logo} alt="MRI Device" />
        </div>
      </div>
      {/* </div> */}
      <Footer />
    </div>
    //   </div>
    // </div>
  );
};

export default AboutUsPage;
